import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../_services/auth.service';

/**
 * Prevent access to routes if access-token is not present.
 *
 * @export
 * @class AuthGuard
 * @implements {CanActivate}
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    return this.checkAccess(state.url);
  }

  async canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    return this.checkAccess(state.url);
  }

  private async checkAccess(url: string): Promise<boolean | UrlTree> {
    const isLoggedIn = await this.authService.isLoggedIn();
    if (!isLoggedIn) {
      return this.router.createUrlTree(['/auth/login'], {
        queryParams: {
          redirectTo: url,
        },
      });
    }

    const sessionUser = await this.authService.syncUserInfo();
    if (!sessionUser) {
      return this.router.createUrlTree(['/auth/login'], {
        queryParams: {
          redirectTo: url,
        },
      });
    }

    return true;
  }
}
